<template>
  <div>
    <el-container>
      <el-header height="64px">
        <MyHeader :menu-data="headerData" :menu-index="headerIndex" :main-click="mainHeaderClick"
                  :sys-click="sysHeaderHeader" :drop-data="dropData"></MyHeader>
      </el-header>
      <HomePage></HomePage>
    </el-container>


    <el-dialog title="企业信息" :visible.sync="dialog.show" width="800px" center>
      <div>
        <div class="w-full flex flex-row">
          <div class="w-2/3 h-24  flex flex-row justify-between border  mr-2">
            <div class="flex flex-col justify-start pl-6">
              <div class="m-2">
                <div class="text-xl font-bold" v-if="systemName">{{ systemName }}</div>
                <el-input v-else v-model="systemNameNew" placeholder="请输入企业名称">
                  <el-button slot="append" icon="el-icon-edit" @click="setSystemName(systemNameNew)">保存</el-button>
                </el-input>
              </div>
              <div class="ml-1 mt-2 text-zinc-400">
                <span>账号：{{ loginAccount }}</span><span class="mx-1 inline-block">|</span><span>角色：{{ roleName }}</span>
              </div>
            </div>
            <div class="flex flex-col justify-start items-end pr-4 mt-2.5">
              <div class="text-zinc-400">短信剩余</div>
              <div class="text-xl font-bold mt-1">{{ smsLeft }}</div>
            </div>
          </div>
          <div class="w-1/3 ml-2 border  flex flex-col justify-between">
            <div class="flex flex-row justify-between items-center m-2">
              <div class="text-xl font-bold">企业版</div>
              <div>{{ dialog.info }}</div>
            </div>
            <div class="pb-2 flex justify-center">
            </div>
          </div>
        </div>
        <el-table class="my-8" :data="smsUseLog" border stripe>
          <el-table-column prop="createTime" label="发放时间" width="180">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | formatDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="beginDate" label="开始日期"></el-table-column>
          <el-table-column prop="endDate" label="截止日期"></el-table-column>
          <el-table-column prop="amount" label="免费短信(条)"></el-table-column>
          <el-table-column prop="realAmount" label="已使用(条)"></el-table-column>
        </el-table>

        <div>
        </div>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import MyHeader from './Header.vue'
import {mapMutations} from "vuex";
import HomePage from "@/pages/HomePage.vue";
import {getSystemInfoSetting, setSystemSettingInfo} from "@/api/setting-api";
import {getListTransSms} from "@/api/log-api";
import {getAllRoleList} from "@/api/role-api";

export default {
  name: 'MyPage',

  data: function () {
    return {
      headerIndex: 'home',
      headerData: [
        {label: '首页大屏', name: 'home'},
        {label: '访客记录', name: 'visitorSystem'},
        {label: '硬件管理', name: 'hardwareManagement'},
        {label: '员工管理', name: 'employeeManagement'},
        {label: '访客管理', name: 'visitorManagement'},
        {label: '角色管理', name: 'roleManage'},
        {label: '系统设置', name: 'systemManagement'},
        // {label: '日志查看', name: 'logManagement'},
      ],

      dropData: [
        // {command: 'logManagement', label: '日志查看'},
        {command: 'info', label: '个人中心'},
        // {command: 'license', label: '企业信息'},
        {command: 'exit', label: '退出登录'},
      ],
      headerAsideMap: {
        visitorSystem: [
          {name: 'subscribe', label: '访客预约', icon: 'el-icon-s-order'},
          {name: 'invite', label: '邀约访客', icon: 'el-icon-s-order'},
          {name: 'visitors', label: '到访记录', icon: 'el-icon-s-order'},
          {name: 'usualVisitorLog', label: '常访记录', icon: 'el-icon-s-order'},
          // {name: 'entranceGuardLog', label: '门禁记录', icon: 'el-icon-s-order'},
        ],

        hardwareManagement: [
          {name: 'deviceManager', label: '访客设备', icon: 'el-icon-s-ticket'},
          {name: 'entranceGuardDevice', label: '门禁设备', icon: 'el-icon-s-ticket'},
          {name: 'deviceArea', label: '区域管理', icon: 'el-icon-s-ticket'},
        ],
        employeeManagement: [
          {name: 'organizearch', label: '组织架构', icon: 'el-icon-s-custom'},
          {name: 'departmentemployee', label: '部门员工', icon: 'el-icon-s-custom'},
          {name: 'membermanage', label: '成员管理', icon: 'el-icon-s-custom'},
        ],
        visitorManagement: [
          {name: 'visitormanager', label: '访客查询', icon: 'el-icon-s-check'},
          {name: 'usualvisitor', label: '常访人员', icon: 'el-icon-s-check'},
          {name: 'providerVisitor', label: '供应商人员', icon: 'el-icon-s-check'},
          {name: 'blacklist', label: '黑名单人员', icon: 'el-icon-s-check'},
        ],
        logManagement: [
          {name: 'smsLog', label: '短信日志', icon: 'el-icon-s-data'},
          {name: 'operationLog', label: '操作日志', icon: 'el-icon-s-data'},
          {name: 'syncLog', label: '同步日志', icon: 'el-icon-s-data'},
          {name: 'backupLog', label: '备份日志', icon: 'el-icon-s-data'},
        ],
        info: [
          {name: 'accountinfo', label: '个人信息', icon: 'el-icon-s-custom'}
        ],
        roleManage: [
          {name: 'roleManage', label: '自定义角色', icon: 'el-icon-user-solid'},
          {name: 'roleSystem', label: '系统内置角色', icon: 'el-icon-user-solid'},
        ],
        systemManagement: [
          {name: 'publicSetting', label: '公共设置', icon: 'el-icon-s-tools'},
          {name: 'entranceGuard', label: '门禁设置', icon: 'el-icon-s-tools'},
          {name: 'employeeSettingPage', label: '员工信息', icon: 'el-icon-s-tools'},
          {name: 'visitorInfoSetting', label: '访客信息', icon: 'el-icon-s-tools'},
          {name: 'webSetting', label: '网页端设置', icon: 'el-icon-s-tools'},
          {name: 'visitorSetting', label: '访客机设置', icon: 'el-icon-s-tools'},
          {name: 'mobileSetting', label: '移动端设置', icon: 'el-icon-s-tools'},
          {name: 'timerSetting', label: '定时器任务', icon: 'el-icon-s-tools'},
        ],
      },

      asideIndex: '',
      asideData: [],

      dialog: {
        show: false,
        info: "",
      },


      systemName: "",
      systemNameNew: "",
      smsUseLog: [],
      roleMap: {
        ADMIN: "超级管理员",
        MANAGE: "系统管理员",
        VIEW: "系统查看员",
      },
      roleName: "",
      smsLeft: 0,
    }
  },
  computed: {
    loginInfo() {
      if (this.$store.state.accountType === 'manage') {
        return this.$store.state.loginInfo
      } else {
        return this.$store.state.employeeLoginInfo
      }
    },
    loginAccount() {
      if (this.$store.state.accountType === 'manage') {
        return this.$store.state.loginInfo.name
      } else {
        return this.$store.state.employeeLoginInfo.loginName
      }
    },
    roleType() {
      return this.$store.state.roleType
    },

  },
  components: {HomePage, MyHeader},

  beforeMount() {
    console.log("=================================================")
    this.setupPagePermission()

  },

  mounted() {

    getSystemInfoSetting().then(({data}) => {
      if (data.code === 200) {
        data.data.forEach((item) => {
          if (item.type === "ENTERPRISE_INFO") {
            this.systemName = item.content
          }
        })
      }
    }).catch((error) => {
      console.log("error =>", error)
      this.showNetErrMsg()
    })

    getAllRoleList().then(({data}) => {
      if (data.code === 200) {
        this.roleList = data.data
        data.data.forEach((item) => {
          this.roleMap[item.id] = item.name
        })
        if (this.roleType === "COMMON") {
          this.roleName = this.roleMap[this.loginInfo.roleValue]
        } else {
          this.roleName = this.roleMap[this.roleType]
        }

      } else {
        this.showServerErrMsg(data.code);
      }
    }).catch(() => {
      this.showNetErrMsg();
    })
    this.requestSmsUseLog()
  },

  methods: {
    ...
        mapMutations(['setLoginData', 'setPageInfo', 'setMyPermission', 'setMyApplyDepartmentIds', 'setMyArriveDepartmentIds',
          'setEmployeeLoginData', "setRoleData", "doOnLogout", "setMyArriveAreaIds", "setMyApplyAreaIds"]),

    requestSmsUseLog() {
      getListTransSms().then(({data}) => {
        if (data.code === 200) {
          console.log("getListTransSms", data)
          this.smsUseLog = data.data
          if (data.data.length > 0) {
            this.smsLeft = data.data[0].amount - data.data[0].realAmount
          }
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((error) => {
        console.log("error =>", error)
        this.showNetErrMsg()
      })
    },

    setSystemName(name) {
      const postData = {
        target: "MANAGE",
        type: "ENTERPRISE_INFO",
        content: name,
        state: "VALID"
      }
      setSystemSettingInfo(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success("保存成功")
          this.systemName = name
        } else {
          this.showServerErrMsg(data)
        }
      }).catch((err) => {
        this.showNetErrMsg(err)
      })
    },

    mainHeaderClick(index) {
      console.log("page headerClick", index, typeof index)
      if (index === 'home') {
        this.headerIndex = index
        this.$router.push({name: index})
        return
      }

      if (this.headerIndex !== index) {
        let curMenuData = this.headerAsideMap[index]
        let asideIndex = curMenuData[0].name
        this.changeAside(curMenuData, asideIndex)
      }
      this.headerIndex = index
    },

    changeAside(data, name) {
      console.log("page changeAside", data, name)
      this.asideData = data
      this.asideIndex = name
      if (name) {
        this.$router.push({name: name})
      }
    },

    sysHeaderHeader(command) {
      console.log("page sysHeaderHeader", command)
      if (command === 'exit') {
        this.changeAside([], "")
        this.doOnLogout()
        this.$router.push({name: 'login'})
      } else if (command === 'info') {
        this.changeAside(this.headerAsideMap.info, "accountinfo")
        this.headerIndex = "info"
      } else if (command === 'roleManage') {
        this.changeAside(this.headerAsideMap.roleManage, "roleManage")
        this.headerIndex = "roleManage"
      } else if (command === 'logManagement') {
        this.changeAside(this.headerAsideMap.logManagement, "smsLog")
        this.headerIndex = "logManagement"
      }
    },

    asideClick(item) {
      console.log("page asideClick", item)

      this.asideIndex = item.name

      if (this.$route.name !== item.name) {
        this.$router.push({name: item.name})
      }
    },

    setupCommonPermission() {
      let myPermissions = []
      let myArriveDepartmentIds = []
      let myApplyDepartmentIds = []
      let myArriveAreaIds = []
      let myApplyAreaIds = []
      if (this.$store.state.roleData == null || this.$store.state.roleData.permissions.length === 0) {
        return
      }
      this.$store.state.roleData.permissions.forEach((level1) => {
        level1.items.forEach((level2) => {

          if (level2.state === "VALID") {
            myPermissions.push(level2.type)

            if (level1.target === "VISITOR_TOP_DEPARTMENT") {
              if (level2.type === 'APPLY_RECORD_SELECT') {
                myApplyDepartmentIds.push(level1.departmentId)
              }
              if (level2.type === 'ARRIVE_RECORD_SELECT') {
                myArriveDepartmentIds.push(level1.departmentId)
              }
            } else if (level1.target === "VISITOR_TOP_AREA") {
              if (level2.type === 'APPLY_RECORD_SELECT') {
                myApplyAreaIds.push(level1.areaId)
              }
              if (level2.type === 'ARRIVE_RECORD_SELECT') {
                myArriveAreaIds.push(level1.areaId)
              }
            }
          }
        })
      })

      this.setMyPermission(myPermissions)
      this.setMyArriveDepartmentIds(myArriveDepartmentIds)
      this.setMyApplyDepartmentIds(myApplyDepartmentIds)
      this.setMyArriveAreaIds(myArriveAreaIds)
      this.setMyApplyAreaIds(myApplyAreaIds)

      const visitorSystemGroup = ["APPLY_RECORD_SELECT", "ARRIVE_RECORD_SELECT", "VISITOR_FORM_SELECT",
        "VISITOR_FORM_MODIFY", "VISITOR_FLOW_SELECT", "VISITOR_FLOW_MODIFY"]
      const hardwareManagementGroup = ["AREA_MANAGE_SELECT", "AREA_MANAGE_MODIFY", "DEVICE_MANAGE_SELECT", "DEVICE_MANAGE_MODIFY",]
      const employeeManagementGroup = ["EMPLOYEE_MANAGE_SELECT", "EMPLOYEE_MANAGE_MODIFY"]
      const visitorManagementGroup = ["VISITOR_MANAGE_SELECT", "VISITOR_MANAGE_MODIFY"]
      const logManagementGroup = ["LOG_MANAGE_SELECT"]
      const roleManageGroup = ["ROLE_MANAGE_SELECT", "ROLE_MANAGE_MODIFY"]
      const systemManagerGroup = ["SYSTEM_SETTING_SELECT", "SYSTEM_SETTING_MODIFY"]

      const visitorSystemCheck = visitorSystemGroup.some((item) => {
        return myPermissions.includes(item)
      })

      const hardwareManagementCheck = hardwareManagementGroup.some((item) => {
        return myPermissions.includes(item)
      })
      const employeeMManagementCheck = employeeManagementGroup.some((item) => {
        return myPermissions.includes(item)
      })
      const visitorManagementCheck = visitorManagementGroup.some((item) => {
        return myPermissions.includes(item)
      })
      const logManagementCheck = logManagementGroup.some((item) => {
        return myPermissions.includes(item)
      })
      const roleManageCheck = roleManageGroup.some((item) => {
        return myPermissions.includes(item)
      })

      const systemManagerCheck = systemManagerGroup.some((item) => {
        return myPermissions.includes(item)
      })

      let headerData = []
      headerData.push({label: '首页大屏', name: 'home'})

      if (visitorSystemCheck) {
        headerData.push({label: '访客记录', name: 'visitorSystem'})
        let visitorData = []
        const visitor1_1Group = ["APPLY_RECORD_SELECT", "VISITOR_FORM_SELECT", "VISITOR_FORM_MODIFY", "VISITOR_FLOW_SELECT", "VISITOR_FLOW_MODIFY"]
        if (visitor1_1Group.some((item) => {
          return myPermissions.includes(item)
        })) {
          visitorData.push({name: 'subscribe', label: '访客预约', icon: 'el-icon-s-order'})
          visitorData.push({name: 'invite', label: '邀约访客', icon: 'el-icon-s-order'})
        }
        if (myPermissions.includes("ARRIVE_RECORD_SELECT")) {
          visitorData.push({name: 'visitors', label: '访客记录', icon: 'el-icon-s-order'})
          visitorData.push({name: 'usualVisitorLog', label: '常访记录', icon: 'el-icon-s-order'})
          // visitorData.push({name: 'entranceGuardLog', label: '门禁记录', icon: 'el-icon-s-order'})
        }
        this.headerAsideMap.visitorSystem = visitorData
      } else {
        this.headerAsideMap.visitorSystem = null
      }

      if (hardwareManagementCheck) {
        headerData.push({label: '硬件管理', name: 'hardwareManagement'})
        let hardData = []
        if (myPermissions.includes("DEVICE_MANAGE_SELECT") || myPermissions.includes("DEVICE_MANAGE_MODIFY")) {
          hardData.push({name: 'deviceManager', label: '设备管理', icon: 'el-icon-s-ticket'})
          hardData.push({name: 'entranceGuardDevice', label: '门禁设备', icon: 'el-icon-s-ticket'})
        }
        if (myPermissions.includes("AREA_MANAGE_SELECT") || myPermissions.includes("AREA_MANAGE_MODIFY")) {
          hardData.push({name: 'deviceArea', label: '区域管理', icon: 'el-icon-s-ticket'})
        }
        this.headerAsideMap.hardwareManagement = hardData
      } else {
        this.headerAsideMap.hardwareManagement = null
      }

      if (employeeMManagementCheck) {
        headerData.push({label: '员工管理', name: 'employeeManagement'})
        let employeeData = []
        if (myPermissions.includes("EMPLOYEE_MANAGE_SELECT") || myPermissions.includes("EMPLOYEE_MANAGE_MODIFY")) {
          employeeData.push({name: 'organizearch', label: '组织架构', icon: 'el-icon-s-custom'})
          employeeData.push({name: 'departmentemployee', label: '部门员工', icon: 'el-icon-s-custom'})
          employeeData.push({name: 'membermanage', label: '成员管理', icon: 'el-icon-s-custom'})
        }
        this.headerAsideMap.employeeManagement = employeeData
      } else {
        this.headerAsideMap.addressBookManagement = []
      }

      if (visitorManagementCheck) {
        headerData.push({label: '访客管理', name: 'visitorManagement'})
        this.headerAsideMap.visitorManagement = [
          {name: 'visitormanager', label: '访客管理', icon: 'el-icon-s-check'},
          {name: 'usualvisitor', label: '常访人员', icon: 'el-icon-s-check'},
          {name: 'providerVisitor', label: '供应商人员', icon: 'el-icon-s-check'},
          {name: 'blacklist', label: '黑名单人员', icon: 'el-icon-s-check'},
        ]
      } else {
        this.headerAsideMap.visitorManagement = null
      }

      if (roleManageCheck) {
        headerData.push({label: '角色管理', name: 'roleManage'})
      } else {
        this.headerAsideMap.roleManage = null
      }

      if (systemManagerCheck) {
        headerData.push({label: '系统设置', name: 'systemManagement'})
      } else {
        this.headerAsideMap.systemManagement = null
      }

      if (logManagementCheck) {
        this.dropData = [
          {command: 'logManagement', label: '日志查看'},
          {command: 'info', label: '个人中心'},
          // {command: 'license', label: '企业信息'},
          {command: 'exit', label: '退出登录'},
        ]
      } else {
        this.headerAsideMap.logManagement = null
      }


      this.headerData = headerData

      console.log("@@@@@@@@@@@@@@@@@@@@@@")
      console.log("111", myPermissions)
      console.log("menu leve1 ", headerData)
      console.log("menu leve1 ", this.headerData)
      console.log("menu leve2 ", this.headerAsideMap)
      console.log("@@@@@@@@@@@@@@@@@@@@@@")
    },

    setupPagePermission() {
      let pageInfo = this.$store.state.pageInfo
      console.log("======>> ", this.pageInfo)

      switch (this.roleType) {
        case "ADMIN":
          this.headerAsideMap.info.push({name: 'accountmanage', label: '账号管理', icon: 'el-icon-s-custom'})
          this.dropData = [
            {command: 'logManagement', label: '日志查看'},
            {command: 'info', label: '个人中心'},
            {command: 'license', label: '企业信息'},
            {command: 'exit', label: '退出登录'},
          ]
          break
        case "MANAGE":
          this.dropData = [
            {command: 'logManagement', label: '日志查看'},
            {command: 'info', label: '个人中心'},
            {command: 'license', label: '企业信息'},
            {command: 'exit', label: '退出登录'},
          ]
          this.headerData = [
            {label: '首页大屏', name: 'home'},
            {label: '访客记录', name: 'visitorSystem'},
            {label: '硬件管理', name: 'hardwareManagement'},
            {label: '员工管理', name: 'employeeManagement'},
            {label: '访客管理', name: 'visitorManagement'},
            {label: '角色管理', name: 'roleManage'},
            {label: '系统设置', name: 'systemManagement'},
          ]
          break
        case "VIEW":
          this.dropData = [
            {command: 'logManagement', label: '日志查看'},
            {command: 'info', label: '个人中心'},
            // {command: 'license', label: '企业信息'},
            {command: 'exit', label: '退出登录'},
          ]
          this.headerData = [
            {label: '首页大屏', name: 'home'},
            {label: '访客记录', name: 'visitorSystem'},
            {label: '硬件管理', name: 'hardwareManagement'},
            {label: '员工管理', name: 'employeeManagement'},
            {label: '访客管理', name: 'visitorManagement'},
            {label: '角色管理', name: 'roleManage'},
            {label: '系统设置', name: 'systemManagement'},
          ]
          break
        case "HOME":
          this.headerData = [
            {label: '首页大屏', name: 'home'},
          ]
          break
        case "COMMON":
          this.setupCommonPermission()
          break

      }

      if (pageInfo.routeName && pageInfo.routeName === this.$router.currentRoute.name) {
        let asideData = this.headerAsideMap[pageInfo.headerIndex]
        let checkPageInfoOk = false

        if (asideData && asideData.length > 0) {
          asideData.forEach((item) => {
            if (item.name === pageInfo.asideIndex) {
              checkPageInfoOk = true
            }
          })
        }

        if (checkPageInfoOk) {
          this.headerIndex = pageInfo.headerIndex
          this.asideIndex = pageInfo.asideIndex
          this.asideData = asideData
          console.log("######################")
          console.log("pageInfo ", pageInfo)
          console.log("######################")
          this.$router.push({name: pageInfo.routeName})
          return
        }
      }
      //
      // if (this.headerData.length > 1) {
      //   this.mainHeaderClick(this.headerData[1].name)
      // } else {
      //   this.mainHeaderClick(this.headerData[0].name)
      // }
    },


  },
  watch: {
    headerIndex(newVal, oldVal) {
      console.log("page headerIndex", newVal, oldVal)
      this.setPageInfo({headerIndex: newVal, asideIndex: this.asideIndex, routeName: this.$route.name})
    },
    asideIndex(newVal, oldVal) {
      console.log("page asideIndex", newVal, oldVal)
      this.setPageInfo({headerIndex: this.headerIndex, asideIndex: newVal, routeName: this.$route.name})
    },
  },
  filters: {
    formatDate(time) {
      return time.substr(0, 10) + " " + time.substr(11, 8)
    }
  }
}
</script>

<style lang="less" scoped>

.el-container {
  box-sizing: border-box;
  min-height: 100vh;
  background: #f5f7fb;
}

.el-header {
  padding: 0;
  height: 64px;
  line-height: 64px;
}

.el-main {
  box-sizing: border-box;
}

</style>
